import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";

const StyledButton = withStyles({
  root: {
    background: "#74AE02",
    "&:hover": {
      backgroundColor: "#74AE02"
    }
  },
  label: {
    textTransform: "capitalize"
  }
})(Button);

export default StyledButton;



// WEBPACK FOOTER //
// ./src/components/common/StyledButton.js